/** @format */
import { ModelPriceModifierGroup } from '@toucan/client/global/model';

export type GroupedPriceModifierGroups = {
    essential: ModelPriceModifierGroup[];
    extra: ModelPriceModifierGroup[];
};

export function getPriceModifierGroupsQueryKey(modelId: number | null) {
    return ['price-modifier-groups', modelId];
}

export function groupPriceModifierGroups(
    data: ModelPriceModifierGroup[]
): GroupedPriceModifierGroups {
    const essential: ModelPriceModifierGroup[] = [];
    const extra: ModelPriceModifierGroup[] = [];

    [...data]
        .sort((a, b) => a.name.localeCompare(b.name))
        .forEach((item) => {
            const group = {
                ...item,
                modifiers: [...item.modifiers].sort((a, b) =>
                    a.name.localeCompare(b.name)
                ),
            };

            if (item.isEssential) {
                essential.push(group);
            } else {
                extra.push(group);
            }
        });

    return { essential, extra };
}
